import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
import { FileElement } from '../model/file-element';
import { Sort } from './sort';

@Directive({
  selector: '[appSort]'
})
export class SortDirective {

  @Input() appSort : Array<FileElement>
  constructor(private renderer: Renderer2, private targetElem: ElementRef) { }

  @HostListener("click")
  sortData(){
    console.log('inside sortdata()')
    const sort = new Sort()
    const elem = this.targetElem.nativeElement
    const order = elem.getAttribute("data-order")
    const type = elem.getAttribute("data-type")
    const property = elem.getAttribute("data-name")

    console.log('elem:'+elem+', order:'+order+', type:'+type+', prop:'+property)
    // console.log(this.appSort)
    if(order === 'desc'){
      this.appSort.sort(sort.startSort(property, order, type))
      console.log('desc')
      console.log(this.appSort)
      elem.setAttribute("data-order", "asc")
    } 
    else{
      this.appSort.sort(sort.startSort(property, order, type))
      console.log('asc')
      console.log(this.appSort)
      elem.setAttribute("data-order", "desc")
    }
  }


}
